'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './event-reservation-list.routes';

export class EventReservationListComponent {
  constructor($stateParams, ReservableEventService, Auth, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.isAdmin = Auth.isAdminSync;

    ReservableEventService.getByType({type: this.type},events => this.data = events);

    /*
    this.data = [{
      title: 'First Event',
      description: '<b>A super nice</b> event that takes places near the south east station of Takimata',
      start: new Date(),
      picture: '5b34a53ba596350ed05dba8a'
    },{
      title: 'Hunt the white rabbit',
      description: 'This will <em>blow your mind</em>. Join us to hunt the white rabbit.',
      start: new Date(),
      picture: '5b34afd0004d70104362719b'
    }];
    */
  }
}

export default angular.module('conduuApp.eventReservationList', [uiRouter])
  .config(routes)
  .component('eventReservationList', {
    template: require('./event-reservation-list.html'),
    controller: EventReservationListComponent,
    controllerAs: 'ctrl',
    bindings: {
      type: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/event/list/event-reservation-list.component.js